
import { useEffect } from 'react';
import { useLocation, NavLink,Link } from 'react-router-dom';
import Highlights from'../Component/Highlights' 
import LazyLoad from 'react-lazyload';
const Header = () => {
  const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  return (
        <> 
        <div className="header"> 
        <div className="logo">
            <NavLink to="/">
              <LazyLoad><img src="https://webapi.entab.info/api/image/MMSKN/public/Images/logo.png" alt="Mercy Memorial School, Kanpur" className="img-fluid"/></LazyLoad>
              </NavLink>
        </div>
        <div className="header-nav">
        <Highlights/>
            <nav className="navbar navbar-expand-lg">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="main_nav">
                <ul className="navbar-nav"> 
                <li className="nav-item"><Link to="/">home</Link></li>
                     <li className="nav-item dropdown"> 
                       <div className="nav-link" data-bs-toggle="dropdown"> about us</div> 
                           <ul className="dropdown-menu fade-up"> 
                                <li><NavLink  className="dropdown-item" to="/AboutUs">History </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/OurVision">Our Vision </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/Founder">Founder </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/Accreditation">Accreditation </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/ManagerMessage">Manager's Message </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/PrincipalMessage"> Principal's Message </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/VicePrincipal">Vice Principal </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/HeadMistress">Head-Mistress's </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/Infrastructure">Infrastructure </NavLink></li>
                           </ul>    
                    </li> 
                    <li className="nav-item dropdown">
                      <div className="nav-link" data-bs-toggle="dropdown"><NavLink  className="dropdown-item" to="/">academics </NavLink></div>  
                           <ul className="dropdown-menu fade-up">
                                <li><NavLink  className="dropdown-item" to="/Academics">Academics </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/StudentCouncil">Student Council </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/SchoolCalendar">School Calendar </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/Curriculum">Curriculum </NavLink></li>
                                
                                <li><NavLink  className="dropdown-item" to="/Prospectus">Prospectus </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/Studies">Studies </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/Examination">Examinations </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/Uniform">Uniform </NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/Timings">Timings </NavLink></li> 
                        </ul>   
                    </li>
                    <li className="nav-item dropdown">
                       <div className="nav-link" data-bs-toggle="dropdown"><NavLink  className="dropdown-item" to="/"> rules</NavLink> </div>  
                             <ul className="dropdown-menu fade-up">
                             <li><NavLink  className="dropdown-item" to="/GeneralRule">General </NavLink></li>
                             <li><NavLink  className="dropdown-item" to="/Discipline">Discipline </NavLink></li>
                             {/* <li><NavLink  className="dropdown-item" to="/Fee">Fee </NavLink></li> */}
                             <li><NavLink  className="dropdown-item" to="/Leave">Leave </NavLink></li>
                             <li><NavLink  className="dropdown-item" to="/Library">Library </NavLink></li>
                             <li><NavLink  className="dropdown-item" to="/Laboratory">Laboratory </NavLink></li>
                             <li><NavLink  className="dropdown-item" to="/RecommendationParents">Parent </NavLink></li>
                             <li><NavLink  className="dropdown-item" to="/Promotion">Promotion </NavLink></li>
                        </ul>   
                    </li>
                    <li className="nav-item dropdown"> 
                      <div className="nav-link" data-bs-toggle="dropdown"><NavLink  className="dropdown-item" to="/"> admission</NavLink></div>  
                            <ul className="dropdown-menu fade-up">
                            <li><NavLink  className="dropdown-item" to="/Criteria">Criteria </NavLink></li>
                            <li><NavLink  className="dropdown-item" to="/FeeStructure">Fee Structure </NavLink></li>
                              {/*   <li><NavLink  className="dropdown-item" to="/FeeSchedule">Fee Payment </NavLink></li>*/}
                            <li><NavLink  className="dropdown-item" to="/">Enquiry </NavLink></li>
                        </ul>   
                    </li>  
                    <li className="nav-item dropdown"> 
                      <div className="nav-link" data-bs-toggle="dropdown"><NavLink  className="dropdown-item" to="/">icse</NavLink></div>  
                             <ul className="dropdown-menu fade-up">
                             <li><NavLink  className="dropdown-item" to="/ICSECriteria">Admission Criteria </NavLink></li> 
                             <li><NavLink  className="dropdown-item" to="/ICSEToppers">Toppers </NavLink></li>
                             <li><NavLink  className="dropdown-item" to="/ICSEresult">Result </NavLink></li>
                        </ul>  
                    </li>  
                    <li className="nav-item dropdown"> 
                      <div className="nav-link" data-bs-toggle="dropdown"><NavLink  className="dropdown-item" to="/">isc</NavLink></div>  
                       <ul className="dropdown-menu fade-up">
                             <li><NavLink  className="dropdown-item" to="/ISCcriteria">Admission Criteria </NavLink></li> 
                             <li><NavLink  className="dropdown-item" to="/ISCToppers">Toppers </NavLink></li>
                             <li><NavLink  className="dropdown-item" to="/ISCresult">Result </NavLink></li>
                        </ul>    
                    </li>  

                    <li className="nav-item dropdown"> 
                    <div className="nav-link" data-bs-toggle="dropdown"><NavLink  className="dropdown-item" to="/">gallery</NavLink></div>  
                     <ul className="dropdown-menu fade-up">
                           <li><NavLink  className="dropdown-item" to="/gallery">gallery</NavLink></li> 
                           <li><NavLink  className="dropdown-item" to="/VideoGallery">Video Gallery </NavLink></li> 
                      </ul>    
                    </li> 
                      
                  <li className="nav-item"><NavLink className="dropdown-item" to="/Circular"> circular </NavLink></li>  
                  <li className="nav-item"><NavLink className="dropdown-item" to="/ContactUs"> contact us </NavLink></li>  
                  
                </ul>
                </div> 
           </nav>
        </div> 
    </div>
    </>
  )
}

export default Header
